module.exports = __webpack_public_path__ + "static/media/diagnostico_imagenes_new.a240f8b2.jpeg";